import { Download, Share2 } from "lucide-react";
import { toast } from "sonner";

export function FlyerActions({ flyer }) {
  const share = async () => {
    const url = `${window.location.origin}/`;
    if (navigator.share) {
      try { await navigator.share({ title: "Dr.Gadget — Expert tech support by phone, video or in person", text: "Dr.Gadget fixes your tech problems by phone or video, and installs TVs, cameras and audio across LA. Book a session:", url }); } catch { /* user cancelled */ }
      return;
    }
    try { await navigator.clipboard.writeText(url); toast.success("Link copied — paste it anywhere"); }
    catch { toast.error("Couldn't copy — the address is " + url); }
  };
  return (
    <div className="mt-4 flex flex-wrap justify-center lg:justify-start gap-3" data-testid="flyer-actions">
      <a href={flyer} download="Dr.Gadget-flyer.png" className="dg-btn-ghost rounded-full px-4 py-2.5 text-xs flex items-center gap-2" data-testid="flyer-download-btn">
        <Download className="w-3.5 h-3.5" /> Save flyer
      </a>
      <button type="button" onClick={share} className="dg-btn-ghost rounded-full px-4 py-2.5 text-xs flex items-center gap-2" data-testid="flyer-share-btn">
        <Share2 className="w-3.5 h-3.5" /> Share
      </button>
    </div>
  );
}
